"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6352],{

/***/ 78881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": function() { return /* binding */ localeMapping; },
/* harmony export */   "Cg": function() { return /* binding */ getEntries; },
/* harmony export */   "pg": function() { return /* binding */ PAGE_LIMIT; },
/* harmony export */   "q_": function() { return /* binding */ toContentfulLocale; },
/* harmony export */   "wF": function() { return /* binding */ CONTENT_TYPES; }
/* harmony export */ });
/* unused harmony exports UPPER_LIMIT, getAllEntries, getEntry, getEntryById */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var contentful__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10159);
/* provided dependency */ var process = __webpack_require__(83454);






var DEFAULT_ENVIRONMENT = "master";
var spaceId = "3anl2xn7qjgw";
var accessToken = "pUozFjUXpkB6Y6MD-tjOqRinRqvntRR6zOlzNF3HHEs";
if (!spaceId) {
    throw new Error("ENV entry not found: contentful space id");
}
if (!accessToken) {
    throw new Error("ENV entry not found: contentful access token ");
}
var client = (0,contentful__WEBPACK_IMPORTED_MODULE_0__/* .createClient */ .e)({
    space: spaceId,
    accessToken: accessToken,
    environment: process.env.CONTENTFUL_ENVIRONMENT || DEFAULT_ENVIRONMENT
});
var CONTENT_TYPES = {
    hubArticle: "blogArticle",
    hubCategory: "postCategory",
    searchLandingPage: "searchLandingPage",
    seaPage: "seaPage",
    dynamicLandingPage: "newLpMarketingWebsite",
    unsignedCaterers: "unsignedCaterers",
    countryLandingPage: "countryLandingPage",
    partnerLandingPage: "partnerLandingPage",
    hubHomepage: "hubHomepage",
    customerLandingPage: "customerLandingPage",
    homePage: "homePage",
    dynamicPage: "dynamicPage"
};
var PAGE_LIMIT = 20;
var UPPER_LIMIT = 1000;
function getAllEntries() {
    return _getAllEntries.apply(this, arguments);
}
function _getAllEntries() {
    _getAllEntries = _async_to_generator(function() {
        var query;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            query = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                client.getEntries(_object_spread_props(_object_spread({}, query), {
                    limit: UPPER_LIMIT
                }))
            ];
        });
    });
    return _getAllEntries.apply(this, arguments);
}
function getEntry() {
    return _getEntry.apply(this, arguments);
}
function _getEntry() {
    _getEntry = _async_to_generator(function() {
        var query, _ref, items, restData;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    if (query.locale) {
                        query.locale = toContentfulLocale(query.locale);
                    }
                    return [
                        4,
                        client.getEntries(_object_spread_props(_object_spread({}, query), {
                            limit: 1
                        }))
                    ];
                case 1:
                    _ref = _state.sent(), items = _ref.items, restData = _object_without_properties(_ref, [
                        "items"
                    ]);
                    return [
                        2,
                        _object_spread({
                            item: items.length ? items[0] : undefined,
                            items: items
                        }, restData)
                    ];
            }
        });
    });
    return _getEntry.apply(this, arguments);
}
function getEntryById(id) {
    return _getEntryById.apply(this, arguments);
}
function _getEntryById() {
    _getEntryById = _async_to_generator(function(id) {
        var query, item;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    if (query.locale) {
                        query.locale = toContentfulLocale(query.locale);
                    }
                    return [
                        4,
                        client.getEntry(id, query)
                    ];
                case 1:
                    item = _state.sent();
                    return [
                        2,
                        item
                    ];
            }
        });
    });
    return _getEntryById.apply(this, arguments);
}
function getEntries() {
    return _getEntries.apply(this, arguments);
}
function _getEntries() {
    _getEntries = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var query;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            query = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            if (query.locale) {
                query.locale = toContentfulLocale(query.locale);
            }
            return [
                2,
                client.getEntries(query)
            ];
        });
    });
    return _getEntries.apply(this, arguments);
}
function toContentfulLocale(nextLocale) {
    return nextLocale && nextLocale in localeMapping ? localeMapping[nextLocale] : "de-DE";
}
var localeMapping = {
    de: "de-DE",
    en: "en",
    da: "en",
    "da-dk": "en",
    "en-uk": "en",
    "en-de": "en",
    "de-at": "de-DE",
    "de-ch": "de-DE",
    "de-de": "de-DE"
};


/***/ }),

/***/ 16352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y5": function() { return /* binding */ fetchArticleCardsByCategory; },
  "Q_": function() { return /* binding */ fetchRecentArticles; }
});

// UNUSED EXPORTS: fetchAllArticles, fetchArticleBySlug, fetchArticleCategories, fetchArticles, fetchArticlesByCategory, fetchFeaturedArticle, fetchHubHomepage, fetchLatestArticles

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/lib/contentful/client.ts
var client = __webpack_require__(78881);
;// CONCATENATED MODULE: ./src/lib/contentful/shapes.ts



function shapes_articleCardShape(param) {
    var _fields = param.fields, title = _fields.title, description = _fields.description, heroImage = _fields.heroImage, postCategory = _fields.postCategory, hubslug = _fields.hubslug, slug = _fields.slug, _tags = _fields.tags, tags = _tags === void 0 ? [] : _tags, _sys = param.sys, createdAt = _sys.createdAt, updatedAt = _sys.updatedAt;
    return {
        title: title,
        description: description,
        heroImage: heroImage,
        hubslug: hubslug,
        slug: slug,
        tags: tags,
        createdAt: createdAt,
        updatedAt: updatedAt,
        postCategory: (0,src_object_spread/* default */.Z)({
            id: postCategory.sys.id
        }, postCategory.fields)
    };
}
function shapes_articleDetailShape(param) {
    var _fields = param.fields, title = _fields.title, postCategory = _fields.postCategory, slug = _fields.slug, heroImage = _fields.heroImage, body = _fields.body, _metaTitle = _fields.metaTitle, metaTitle = _metaTitle === void 0 ? "" : _metaTitle, _metaDescription = _fields.metaDescription, metaDescription = _metaDescription === void 0 ? "" : _metaDescription, robots = _fields.robots, _tags = _fields.tags, tags = _tags === void 0 ? [] : _tags, _buttonCta = _fields.buttonCta, buttonCta = _buttonCta === void 0 ? "" : _buttonCta, _buttonCtaCopy = _fields.buttonCtaCopy, buttonCtaCopy = _buttonCtaCopy === void 0 ? "" : _buttonCtaCopy, _buttonCtaSubtitle = _fields.buttonCtaSubtitle, buttonCtaSubtitle = _buttonCtaSubtitle === void 0 ? "" : _buttonCtaSubtitle, _buttonUrl = _fields.buttonUrl, buttonUrl = _buttonUrl === void 0 ? "" : _buttonUrl, _suggestedArticles = _fields.suggestedArticles, suggestedArticles = _suggestedArticles === void 0 ? [] : _suggestedArticles, _targetAudience = _fields.targetAudience, targetAudience = _targetAudience === void 0 ? "Customer" : _targetAudience, hasEnglishVersion = _fields.hasEnglishVersion, author = _fields.author, contactForm = _fields.contactForm, _sys = param.sys, createdAt = _sys.createdAt, updatedAt = _sys.updatedAt;
    var ref;
    return {
        title: title,
        slug: slug,
        author: (author === null || author === void 0 ? void 0 : (ref = author.fields) === null || ref === void 0 ? void 0 : ref.avatar) ? _object_spread_props(_object_spread({}, author.fields), {
            avatar: _object_spread({}, author.fields.avatar.fields)
        }) : null,
        heroImage: heroImage,
        body: body,
        metaTitle: metaTitle,
        metaDescription: metaDescription,
        robots: robots,
        tags: tags,
        buttonCta: buttonCta,
        buttonCtaCopy: buttonCtaCopy,
        buttonCtaSubtitle: buttonCtaSubtitle,
        buttonUrl: buttonUrl,
        targetAudience: targetAudience,
        hasEnglishVersion: !!hasEnglishVersion,
        postCategory: _object_spread({}, postCategory.fields),
        suggestedArticles: _to_consumable_array((suggestedArticles.filter(function(article) {
            return !!article.fields;
        }) || []).map(shapes_articleCardShape)),
        createdAt: createdAt,
        updatedAt: updatedAt,
        contactForm: contactForm || null
    };
}

;// CONCATENATED MODULE: ./src/lib/contentful/hub.ts








var SUGGESTED_ARTICLES_LIMIT = 3;
var DEFAULT_LOCALE = client/* localeMapping.de */.AT.de;
var fetchPostCategories = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var locale, items;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : DEFAULT_LOCALE;
                    return [
                        4,
                        (0,client/* getEntries */.Cg)({
                            content_type: client/* CONTENT_TYPES.hubCategory */.wF.hubCategory,
                            limit: 20,
                            locale: locale
                        })
                    ];
                case 1:
                    items = _state.sent().items;
                    return [
                        2,
                        items
                    ];
            }
        });
    });
    return function fetchPostCategories() {
        return _ref.apply(this, arguments);
    };
}();
function fetchAllArticles() {
    return _fetchAllArticles.apply(this, arguments);
}
function _fetchAllArticles() {
    _fetchAllArticles = _async_to_generator(function() {
        var items;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getAllEntries({
                            content_type: CONTENT_TYPES.hubArticle
                        })
                    ];
                case 1:
                    items = _state.sent().items;
                    return [
                        2,
                        items
                    ];
            }
        });
    });
    return _fetchAllArticles.apply(this, arguments);
}
function fetchArticles(query) {
    return _fetchArticles.apply(this, arguments);
}
function _fetchArticles() {
    _fetchArticles = (0,src_async_to_generator/* default */.Z)(function(query) {
        var items;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,client/* getEntries */.Cg)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            content_type: client/* CONTENT_TYPES.hubArticle */.wF.hubArticle,
                            order: "-sys.updatedAt"
                        }, query), {
                            locale: (0,client/* toContentfulLocale */.q_)(query === null || query === void 0 ? void 0 : query.locale)
                        }))
                    ];
                case 1:
                    items = _state.sent().items;
                    return [
                        2,
                        items
                    ];
            }
        });
    });
    return _fetchArticles.apply(this, arguments);
}
function fetchRecentArticles() {
    return _fetchRecentArticles.apply(this, arguments);
}
function _fetchRecentArticles() {
    _fetchRecentArticles = (0,src_async_to_generator/* default */.Z)(function() {
        var locale, items;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : DEFAULT_LOCALE;
                    return [
                        4,
                        fetchArticles({
                            limit: 20,
                            locale: locale,
                            order: "-sys.createdAt"
                        })
                    ];
                case 1:
                    items = _state.sent();
                    return [
                        2,
                        items
                    ];
            }
        });
    });
    return _fetchRecentArticles.apply(this, arguments);
}
function fetchHubHomepage() {
    return _fetchHubHomepage.apply(this, arguments);
}
function _fetchHubHomepage() {
    _fetchHubHomepage = _async_to_generator(function() {
        var locale, item;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    locale = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : DEFAULT_LOCALE;
                    return [
                        4,
                        getEntry({
                            content_type: CONTENT_TYPES.hubHomepage,
                            locale: locale,
                            order: "-sys.updatedAt"
                        })
                    ];
                case 1:
                    item = _state.sent().item;
                    return [
                        2,
                        item === null || item === void 0 ? void 0 : item.fields
                    ];
            }
        });
    });
    return _fetchHubHomepage.apply(this, arguments);
}
function fetchFeaturedArticle() {
    return _fetchFeaturedArticle.apply(this, arguments);
}
function _fetchFeaturedArticle() {
    _fetchFeaturedArticle = _async_to_generator(function() {
        var hubHomepage;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchHubHomepage()
                    ];
                case 1:
                    hubHomepage = _state.sent();
                    if (!(hubHomepage === null || hubHomepage === void 0 ? void 0 : hubHomepage.featuredPost)) {
                        return [
                            2,
                            undefined
                        ];
                    }
                    return [
                        2,
                        articleCardShape(hubHomepage.featuredPost)
                    ];
            }
        });
    });
    return _fetchFeaturedArticle.apply(this, arguments);
}
function fetchLatestArticles(locale) {
    return _fetchLatestArticles.apply(this, arguments);
}
function _fetchLatestArticles() {
    _fetchLatestArticles = _async_to_generator(function(locale) {
        var items;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchArticles({
                            limit: 6,
                            locale: locale,
                            order: "-sys.updatedAt"
                        })
                    ];
                case 1:
                    items = _state.sent();
                    return [
                        2,
                        items.map(articleCardShape)
                    ];
            }
        });
    });
    return _fetchLatestArticles.apply(this, arguments);
}
function fetchArticleBySlug(_) {
    return _fetchArticleBySlug.apply(this, arguments);
}
function _fetchArticleBySlug() {
    _fetchArticleBySlug = _async_to_generator(function(param) {
        var slug, _locale, locale, _suggestedArticlesLimit, suggestedArticlesLimit, fetchArticlePromise, ref, item, categories, article, items, recentArticles;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, _locale = param.locale, locale = _locale === void 0 ? DEFAULT_LOCALE : _locale, _suggestedArticlesLimit = param.suggestedArticlesLimit, suggestedArticlesLimit = _suggestedArticlesLimit === void 0 ? SUGGESTED_ARTICLES_LIMIT : _suggestedArticlesLimit;
                    fetchArticlePromise = getEntry({
                        content_type: CONTENT_TYPES.hubArticle,
                        "fields.slug": slug,
                        locale: locale,
                        include: 5
                    });
                    return [
                        4,
                        Promise.all([
                            fetchArticlePromise,
                            fetchPostCategories(locale)
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), item = ref[0].item, categories = ref[1];
                    if (!item || !(item === null || item === void 0 ? void 0 : item.fields)) {
                        return [
                            2
                        ];
                    }
                    article = articleDetailShape(item);
                    if (!(article.suggestedArticles.length < suggestedArticlesLimit)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetchArticlesByCategory({
                            category: article.postCategory.slug,
                            pageLimit: suggestedArticlesLimit - article.suggestedArticles.length
                        })
                    ];
                case 2:
                    items = _state.sent().items;
                    recentArticles = items.filter(function(recentArticle) {
                        return recentArticle.fields.slug !== slug;
                    });
                    article.suggestedArticles = _to_consumable_array(article.suggestedArticles).concat(_to_consumable_array(recentArticles.map(articleCardShape))).map(function(_article) {
                        return mapPostCategoryToArticle(_article, categories);
                    });
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        article
                    ];
            }
        });
    });
    return _fetchArticleBySlug.apply(this, arguments);
}
var mapPostCategoryToArticle = function(article, categories) {
    var categoryId = article.postCategory.id;
    var category = categories.find(function(category) {
        return category.sys.id === categoryId;
    });
    return category ? _object_spread_props(_object_spread({}, article), {
        postCategory: _object_spread_props(_object_spread({}, category.fields), {
            id: category.sys.id
        })
    }) : article;
};
function fetchArticlesByCategory(_) {
    return _fetchArticlesByCategory.apply(this, arguments);
}
function _fetchArticlesByCategory() {
    _fetchArticlesByCategory = (0,src_async_to_generator/* default */.Z)(function(param) {
        var category, _page, page, _pageLimit, pageLimit, _locale, locale, ref, items, total, skip, limit;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    category = param.category, _page = param.page, page = _page === void 0 ? 0 : _page, _pageLimit = param.pageLimit, pageLimit = _pageLimit === void 0 ? client/* PAGE_LIMIT */.pg : _pageLimit, _locale = param.locale, locale = _locale === void 0 ? DEFAULT_LOCALE : _locale;
                    return [
                        4,
                        (0,client/* getEntries */.Cg)({
                            content_type: client/* CONTENT_TYPES.hubArticle */.wF.hubArticle,
                            "fields.postCategory.fields.slug": category,
                            "fields.postCategory.sys.contentType.sys.id": "postCategory",
                            limit: pageLimit,
                            skip: pageLimit * page,
                            locale: locale,
                            order: "-sys.updatedAt"
                        })
                    ];
                case 1:
                    ref = _state.sent(), items = ref.items, total = ref.total, skip = ref.skip, limit = ref.limit;
                    return [
                        2,
                        {
                            items: items,
                            total: total,
                            skip: skip,
                            limit: limit
                        }
                    ];
            }
        });
    });
    return _fetchArticlesByCategory.apply(this, arguments);
}
function fetchArticleCardsByCategory(_) {
    return _fetchArticleCardsByCategory.apply(this, arguments);
}
function _fetchArticleCardsByCategory() {
    _fetchArticleCardsByCategory = (0,src_async_to_generator/* default */.Z)(function(param) {
        var category, _page, page, _pageLimit, pageLimit, locale, ref, items, total, skip, limit;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    category = param.category, _page = param.page, page = _page === void 0 ? 0 : _page, _pageLimit = param.pageLimit, pageLimit = _pageLimit === void 0 ? client/* PAGE_LIMIT */.pg : _pageLimit, locale = param.locale;
                    return [
                        4,
                        fetchArticlesByCategory({
                            category: category,
                            page: page,
                            pageLimit: pageLimit,
                            locale: locale
                        })
                    ];
                case 1:
                    ref = _state.sent(), items = ref.items, total = ref.total, skip = ref.skip, limit = ref.limit;
                    return [
                        2,
                        {
                            items: items.map(shapes_articleCardShape),
                            total: total,
                            skip: skip,
                            limit: limit
                        }
                    ];
            }
        });
    });
    return _fetchArticleCardsByCategory.apply(this, arguments);
}
function fetchArticleCategories(locale) {
    return _fetchArticleCategories.apply(this, arguments);
}
function _fetchArticleCategories() {
    _fetchArticleCategories = _async_to_generator(function(locale) {
        var hubHomepage;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchHubHomepage(locale)
                    ];
                case 1:
                    hubHomepage = _state.sent();
                    if (!(hubHomepage === null || hubHomepage === void 0 ? void 0 : hubHomepage.categories)) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        2,
                        hubHomepage.categories.map(function(item) {
                            return item.fields;
                        })
                    ];
            }
        });
    });
    return _fetchArticleCategories.apply(this, arguments);
}


/***/ })

}]);